import type { FC } from 'react';

import TerminalsAndGroupsMultiSelect from '../../TerminalsAndGroupsMultiSelect';
import type { TerminalOrGroup } from '../../TerminalsAndGroupsSelect';
import type { FormFieldProps } from '../FormField';
import FormField from '../FormField';
import type { FormInstance } from '../types';

interface Props extends FormFieldProps {
  includeGroups?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
  renderMenuInPortal?: boolean;
}

const FormTerminalsAndGroupsMultiSelect: FC<Props> = (props) => {
  const { label, ...rest } = props;

  return (
    <FormField {...props}>
      {(field: { error: boolean; label: string; name: string; value: TerminalOrGroup[] }, form: FormInstance<unknown>) => {
        const { label: fieldLabel, ...fieldRest } = field;

        return (
          <TerminalsAndGroupsMultiSelect
            {...rest}
            {...fieldRest}
            hasError={field.error}
            onChange={(value: TerminalOrGroup[]): void => {
              form.setFieldValue(field.name, value);
            }}
          />
        );
      }}
    </FormField>
  );
};

export type { Props as FormTerminalsAndGroupsMultiSelectProps };

export default FormTerminalsAndGroupsMultiSelect;
